const hasFixedTimeDuplicates = (array: { startTime: string }[]): boolean => {
  const startTimes = array.map(({ startTime }) => startTime);
  return (new Set(startTimes)).size !== startTimes.length;
};

export default hasFixedTimeDuplicates;
